import React, { useState } from "react";
import axios from "axios";
import "../Styles/AddPooja.css";

function AddPooja({ refreshDashboard }) {

  const [pooja, setPooja] = useState({
    name: "",
    date: "",
    time: "",
    amount: "",
    description: ""
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");


  /* =====================================================
     HANDLE INPUT
  ===================================================== */

  const handleChange = (e) => {

    const { name, value } = e.target;

    setPooja({
      ...pooja,
      [name]: value
    });

  };


  /* =====================================================
     ADD POOJA
  ===================================================== */

  const handleSubmit = async (e) => {

    e.preventDefault();

    setMessage("");
    setError("");


    if (
      !pooja.name ||
      !pooja.date ||
      !pooja.time ||
      !pooja.amount ||
      !pooja.description
    ) {

      setError("Please fill all fields.");

      return;
    }


    try {

      await axios.post(
        "http://localhost:8080/api/poojas",
        {
          name: pooja.name,
          date: pooja.date,
          time: pooja.time,
          amount: Number(pooja.amount),
          description: pooja.description,
          active: true
        }
      );


      setMessage("Pooja added successfully.");


      /* Clear form */

      setPooja({
        name: "",
        date: "",
        time: "",
        amount: "",
        description: ""
      });


      /* Refresh right-side dashboard */

      if (refreshDashboard) {
        refreshDashboard();
      }


    } catch (err) {

      console.error("Error adding pooja:", err);

      setError(
        err.response?.data ||
        "Failed to add pooja."
      );

    }

  };


  return (

    <div className="add-pooja-page">


      {/* =================================================
          TITLE
      ================================================= */}

      <h2 className="add-pooja-title">
        🙏 Add Pooja
      </h2>


      {/* =================================================
          SUCCESS MESSAGE
      ================================================= */}

      {message && (
        <div className="pooja-success">
          {message}
        </div>
      )}


      {/* =================================================
          ERROR MESSAGE
      ================================================= */}

      {error && (
        <div className="pooja-error">
          {error}
        </div>
      )}


      {/* =================================================
          FORM
      ================================================= */}

      <form
        className="pooja-form"
        onSubmit={handleSubmit}
      >


        {/* Pooja Name */}

        <div className="pooja-field">

          <label>
            Pooja Name
          </label>

          <input
            type="text"
            name="name"
            value={pooja.name}
            onChange={handleChange}
            placeholder="Enter pooja name"
          />

        </div>


        {/* Date */}

        <div className="pooja-field">

          <label>
            Date
          </label>

          <input
            type="date"
            name="date"
            value={pooja.date}
            onChange={handleChange}
          />

        </div>


        {/* Time */}

        <div className="pooja-field">

          <label>
            Time
          </label>

          <input
            type="time"
            name="time"
            value={pooja.time}
            onChange={handleChange}
          />

        </div>


        {/* Amount */}

        <div className="pooja-field">

          <label>
            Amount (₹)
          </label>

          <input
            type="number"
            name="amount"
            value={pooja.amount}
            onChange={handleChange}
            placeholder="Enter amount"
            min="0"
          />

        </div>


        {/* Description */}

        <div className="pooja-field">

          <label>
            Description
          </label>

          <textarea
            name="description"
            value={pooja.description}
            onChange={handleChange}
            placeholder="Enter pooja description"
            rows="4"
          />

        </div>


        {/* Submit */}

        <button
          type="submit"
          className="add-pooja-button"
        >
          Add Pooja
        </button>


      </form>

    </div>

  );

}

export default AddPooja;